export const ga = () => ({
  // eslint-disable-next-line no-console
  track: window?.analytics?.track || console.log,
  // eslint-disable-next-line no-console
  identify: window?.analytics?.identify || console.log
});
